import React from "react";

function Header() {
  return (
    <header className="title-container">
      <img className="clock-img" src="./img/clock.png" alt="" />
      <img className="title-img" src="./img/title.png" alt="1만 시간의 법칙" />
    </header>
  );
}

export default Header;
